import { useEffect } from 'react';
import {
  APP_TYPE,
  BeatPlanTypeEnum,
  dispatch,
  getAppType,
  getNonPeriodicBeatPlanInfo,
  getUserData,
  getWorkspaceId,
  updateNonPeriodicBeatPlanInfo,
  updatePeriodicBeatPlanInfo,
  useAppSelector,
  useLazyGetBeatPlanInfoQuery,
  useLazyGetRouteScheduleQuery,
} from '@zonofi/zono-money-store';
import { isEmpty, isNil } from 'lodash';

export const useGetBeatPlanType = () => {
  const sellerWorkspaceId = useAppSelector(getWorkspaceId);
  const appType = useAppSelector(getAppType);
  const nonPeriodicBeatPlanInfo = useAppSelector(getNonPeriodicBeatPlanInfo);
  const [getFieldOpsRouteListAPI] = useLazyGetRouteScheduleQuery();
  const teamMemberId = useAppSelector(getUserData).inviteId;

  const [getBeatPlanInfoApi] = useLazyGetBeatPlanInfoQuery();

  useEffect(() => {
    if (sellerWorkspaceId && appType === APP_TYPE.FIELDS_OPS) {
      getBeatPlanInfoApi({ sellerWorkspaceId })
        .unwrap()
        .then((result) => {
          dispatch(updateNonPeriodicBeatPlanInfo(result));
        });
    }
  }, [sellerWorkspaceId, appType]);

  useEffect(() => {
    if (isNil(nonPeriodicBeatPlanInfo)) {
      getFieldOpsRouteListAPI({
        sellerWorkspaceId: sellerWorkspaceId,
        teamMemberId: teamMemberId ?? '',
        pageNo: 1,
        pageSize: 100,
      })
        .unwrap()
        .then((data) => {
          if (isEmpty(data) || isNil(data)) {
            dispatch(updatePeriodicBeatPlanInfo(BeatPlanTypeEnum.Customers));
          } else {
            dispatch(updatePeriodicBeatPlanInfo(BeatPlanTypeEnum.Routes));
          }
        });
    } else {
      dispatch(updatePeriodicBeatPlanInfo(undefined));
    }
  }, [nonPeriodicBeatPlanInfo]);
};
